import axios from 'axios'

// 获取当前用户信息
export function getCurrentUser(params) {
  return axios.get(process.env.VUE_APP_BASE_API + '/user/get', { params })
}

export default {
  getCurrentUser
}
